import { createSlice }      from "@reduxjs/toolkit";

import { usersApi }         from "src/store/services/users";
import type { IUser }       from "src/store/services/users/interfaces/responses.interface";
import type { RootState }   from "src/store/store";
import { RequestStateEnum } from "src/types";

type TReportsState = {
  byUserId: { value: IUser | null; state: RequestStateEnum };
  allUsers: { value: IUser[]; state: RequestStateEnum };
};

const initialState: TReportsState = {
  byUserId: {
    value: null,
    state: RequestStateEnum.NODATA,
  },
  allUsers: { value: [], state: RequestStateEnum.NODATA },
};

const slice = createSlice({
  name         : "usersApi",
  initialState,
  reducers     : {},
  extraReducers: (builder) => {
    // GET All users endpoint reducers
    builder.addMatcher(usersApi.endpoints.getUsers.matchPending, (state) => {
      state.allUsers.state = RequestStateEnum.LOADING;
    });
    builder.addMatcher(usersApi.endpoints.getUsers.matchRejected, (state) => {
      state.allUsers.state = RequestStateEnum.FAILED;
    });
    builder.addMatcher(usersApi.endpoints.getUsers.matchFulfilled,
      (state, { payload }) => {
        state.allUsers.state = RequestStateEnum.FULLFILLED;
        // Handle both old array format and new object format
        state.allUsers.value = Array.isArray(payload) ? payload : payload.data;
      });
    // GET user by id reducers
    builder.addMatcher(usersApi.endpoints.getUserById.matchPending, (state) => {
      state.byUserId.state = RequestStateEnum.LOADING;
    });
    builder.addMatcher(usersApi.endpoints.getUserById.matchRejected,
      (state) => {
        state.byUserId.state = RequestStateEnum.FAILED;
      });
    builder.addMatcher(usersApi.endpoints.getUserById.matchFulfilled,
      (state, { payload }) => {
        state.byUserId.value = payload;
      });
  },
});

export const selectUsers = (state: RootState) => state.users.allUsers;

export const selectUserProfile = (state: RootState) => state.users.byUserId;

export const { reducer: usersReducer } = slice;
